import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axiosInstance from '../components/api/AxiosInstance'; 
import Loading from './Loading';

export default function WorkersInDetail() {
    const { id } = useParams(); // Extract ID from URL
    const [worker, setWorker] = useState(null);

// Loading
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);


    useEffect(() => {
      if (id) {
        axiosInstance.get(`/worker/${id}`, {
          headers: {
            "ngrok-skip-browser-warning": "true",
          },
        })
          .then((response) => {
          setWorker(response.data);
          setIsLoading(false);
  
  
          })
          .catch((error) => {
          console.error('Error fetching department details:', error);
          setIsLoading(false);
  
          });
      }
    }, [id]);
  

   
   if (loading || isLoading) {
      return <Loading />;
    }

    
  return (
    <div>
    <form>
<div className='top-form'>
   <div className='top-form-left'>
   <img  src={`https://nks.qravtojol.uz/image/${worker?.photo}`} alt="Img"/>
   </div>
   <div className='top-form-rigth-2'>
     <div>
        <p>Ismi: <strong>{worker?.name}</strong></p>
     </div>
     <div>
        <p>Familiyasi: <strong>{worker?.surname}</strong></p>
     </div>
     <div>
        <p>Otasining ismi: <strong>{worker?.father_name}</strong></p>
     </div>
     <div>
        <p>Tug'ilgan sana: <strong>{worker?.date_of_birth}</strong></p>
     </div>
     <div>
        <p>Passport ID: <strong>{worker?.passport_number}</strong></p>

     </div>
     <div>
        <p>Millati: <strong>{worker?.nationality}</strong></p>

     </div>
     <div>
        <p>Jinisi: <strong>{worker?.sex}</strong></p>
     </div>
     <div>
        <p>Yashash manzili: <strong>{worker?.address}</strong></p>

     </div>
     <div>
     <a href={`https://nks.qravtojol.uz/download/${worker?.resume}`} target="_blank" rel="noopener noreferrer">View Resume</a>
     </div>
   </div>
</div>
<div className='center-form'>
<h5>{worker?.phone_number}</h5>
<h5>{worker?.email}</h5>
</div>
<div className='bottom-form'>
<div id='border-b' className='bottom-form-item'> 
     <label><strong>Ta'limi Qayerda tugatgan:</strong></label>
     <p>{worker?.malumat}</p>
</div>
<div id='border-b' className='bottom-form-item'>
 <label><strong>Mehnat faoliyati</strong></label> 
 <p>{worker?.mehnat_faoliyati}</p>
</div>
<div id='border-b' className='bottom-form-item'> 
 <label><strong>Ish joyi va lavozimi</strong></label>
 <p>{worker?.ish_joy_lavozim}</p>
</div>
</div>
</form>
</div>
  )
}
